import { render, staticRenderFns } from "./TriangleIcon.vue?vue&type=template&id=42634b81"
import script from "./TriangleIcon.vue?vue&type=script&lang=js"
export * from "./TriangleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports